module.exports = __webpack_public_path__ + "static/flower-right-162d9c98b585787a5ddbd3ba1575b650.png";